import { createRouter, createWebHistory } from 'vue-router'



import Home from '../views/Home.vue'
import Profiles from '../views/Profiles.vue'
import Profile from '../views/Profile.vue'
import TalentPools from '../views/TalentPools.vue'
import TalentPool from '../views/TalentPool.vue'
import Uploads from '../views/Uploads.vue'
import Logout from '../views/Logout.vue'
import Login from '../views/Login.vue'
import ResetPassword from '../views/generifc/ResetPassword.vue'

// Marketplace
// Marketplace Routes
import marketplaceRoutes from './marketplace'
import contractorService from '@/services/marketplace/contractor.service'
import { contractorPortal } from '@/config/contractorPortal'


import store from '../store'

const generalRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      breadcrumbs: false,
      blankHeader: true
    }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      breadcrumbs: false,
      contractorHeader: true
    }
  },
  {
    path: '/admin',
    name: 'Dashboard',
    redirect: '/admin/profiles'
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: Login,
    meta: {
      adminHeader: true,
      breadcrumbs: false
    }
  },
  {
    path: '/admin/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/admin/profiles',
    name: 'Profiles',
    component: Profiles,
    meta: {
      adminHeader: true,
      requiresAuth: true
    }
  },
  {
    path: '/admin/profiles/:profileHash',
    name: 'Individual Profile',
    component: Profile,
    meta: {
      adminHeader: true,
      requiresAuth: true
    }
  },
  {
    path: '/admin/talent-pools',
    name: 'Talent Pools',
    component: TalentPools,
    meta: {
      adminHeader: true,
      requiresAuth: true
    }
  },
  {
    path: '/admin/talent-pools/:poolHash',
    name: 'Individual Pool',
    component: TalentPool,
    beforeEnter: (to, from, next) => {
      window.scrollTo(0, 0)
      next()
    },
    meta: { adminHeader: true }
  },
  {
    path: '/admin/uploads',
    name: 'Uploads',
    component: Uploads,
    meta: {
      adminHeader: true,
      requiresAuth: true
    }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const routes = [
  ...generalRoutes,
  ...marketplaceRoutes
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const STATUS_CACHE_TTL_MS = 15000;
const processingRouteNames = new Set(['ContractorProcessing', 'ContractorLogout']);

const getCachedReady = () => {
  const cachedValue = sessionStorage.getItem('contractorReadyStatus');
  const cachedAt = Number(sessionStorage.getItem('contractorReadyStatusAt') || 0);
  if (!cachedValue || Number.isNaN(cachedAt)) {
    return null;
  }
  if (Date.now() - cachedAt > STATUS_CACHE_TTL_MS) {
    return null;
  }
  return cachedValue === 'true';
};

const setCachedReady = (ready) => {
  sessionStorage.setItem('contractorReadyStatus', ready ? 'true' : 'false');
  sessionStorage.setItem('contractorReadyStatusAt', Date.now().toString());
};

const checkContractorReady = async () => {
  const cached = getCachedReady();
  if (cached !== null) {
    return cached;
  }

  const response = await contractorService.getUploads();
  const data = response.data || {};
  const ready = !!data.active;
  setCachedReady(ready);
  return ready;
};

router.beforeEach(async (to, from, next) => {
  if (contractorPortal.enabled && to.name === 'ContractorProfile') {
    window.location.replace(contractorPortal.dashboardUrl)
    return
  }

  if (contractorPortal.enabled && to.name === 'ContractorLogin') {
    window.location.replace(contractorPortal.loginUrl)
    return
  }

  // if (to.matched.some(record => record.meta.requiresAuth)) {
  if (to.meta.requiresAuth) {
    // this route requires auth, check if logged in
    // See if we have the token
    if (localStorage.getItem("screenedToken") === null) {
      next({ name: 'Login' })
    } else {
      next()
    }
    // if (!store.state.isLoggedIn) {
      //   // Not logged in, redirect to login
      //   next({ name: 'Login' })
      // } else {
      //   next() // Is logged in, go ahead
      // }
  } else if (to.meta.requiresContractorAuth) {
    if (localStorage.getItem("contractorToken") === null) {
      if (contractorPortal.enabled) {
        window.location.replace(contractorPortal.loginUrl)
        return
      }
      next({ name: 'ContractorLogin' })
    } else {
      if (processingRouteNames.has(to.name)) {
        next();
        return;
      }

      try {
        const isReady = await checkContractorReady();
        if (!isReady) {
          next({
            name: 'ContractorProcessing',
            query: { redirect_uri: to.fullPath }
          });
          return;
        }
      } catch (error) {
        // If status check fails, allow navigation to avoid blocking.
      }

      next();
    }
  } else {
    next()
  }
})

export default router
